export { useSelector } from '@wix/bex-core';
